<template>
    <div class="aktivitas-wa-list">
        <div class="m-d-16" v-for="(data, idx) in dataList" :key="`${idx}-${data.id}`">
            <SOSlotCard
                :id="`aktivitas-${data.id}`"
                :card-type="'none'"
                @loadMore="doLoadMore"
                @toogleCard="toggleCard"
                :last-id="getLastId"
            >
                <template v-slot:card_body>
                    <div style="margin: 0 -12px" class="d-grid-12" @click="openDetail(data)">
                        <div class="grid-cspan-4 j-self-center">
                            <div
                                class="wa-status-thumbnail d-flex-between-center"
                                style="background: black; justify-content: center;"
                            >
                                <img v-if="isImage(data.type_media)" :src="`${imageStore}${data.media_name}`" />
                                <label v-if="isText(data.type_media)" class="m-d-0 f-12 f-regular f-c-white">
                                    Caption
                                </label>
                                <img
                                    v-if="isVideo(data.type_media)"
                                    :src="`${imageStore}thumbnail/${data.thumb_name}`"
                                />
                            </div>
                        </div>
                        <div class="grid-cspan-8 p-l-8 p-r-12">
                            <div class="d-grid-12 m-d-8">
                                <div class="grid-cspan-11 f-regular f-14 f-c-black">
                                    <label class="m-d-0" v-if="data.caption">
                                        {{ data.caption }}
                                    </label>
                                    <label class="m-d-0 f-c-midgrey" v-else>
                                        <i>Tanpa caption</i>
                                    </label>
                                </div>
                                <div class="grid-cspan-1">
                                    <img v-if="false" src="@/assets/icon-sidebar/chevron.svg" alt="" />
                                    <img v-else src="@/assets/img/chevron-right 1.svg" alt="" />
                                </div>
                            </div>

                            <!-- Jadwal -->
                            <div class="m-d-8">
                                <div class="f-12 f-c-midgrey">
                                    <label class="m-d-0">
                                        <b>Diposting:</b> {{ dateFormated(data.created_at, $moment) }}
                                    </label>
                                </div>
                            </div>

                            <!-- Per-status -->
                            <label
                                class="wa-status-status f-12 m-d-0"
                                :class="{
                                    blue: data.status === 1,
                                    green: data.status === 2,
                                    red: data.status === 3 || data.status === 4,
                                }"
                                v-if="data.status !== 0"
                            >
                                {{ getTypeStatus(data.status, 1) }}
                                <span v-if="data.status === 3"> • {{ getReason(data.reason) }}</span>
                            </label>
                        </div>
                    </div>
                </template>
            </SOSlotCard>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard";

import { moduleName } from "../store/state";

export default {
    name: "CardAktivitas",
    props: {
        dataList: {
            type: Array,
            required: true,
        },
        dataCount: {
            type: Number | String,
            default: 0,
        },
        iddevice: {
            type: String,
            required: true,
        },
        idStatus: {
            type: Number | String,
            required: true,
        },
    },
    components: {
        SOSlotCard,
    },
    computed: {
        ...mapGetters(moduleName, {
            getTypeStatus: "getTypeStatus",
            dateFormated: "dateFormated",
            imageStore: "imageStore",
            isVideo: "isVideo",
            isImage: "isImage",
            isText: "isText",
            isFetching: "isFetching",
            aktivitasEnd: "aktivitasEnd",
            aktivitasTotal: "aktivitasTotal",
            aktivitasPage: "aktivitasPage",
        }),
        getLastId() {
            return this.aktivitasEnd.id ? `aktivitas-${this.aktivitasEnd.id}` : "";
        },
        getReason() {
            return (reason) => {
                return reason === "saldo_kurang" ? "M-coin tidak cukup" : "Masalah koneksi";
            };
        },
    },
    methods: {
        ...mapActions({
            toggleAktivitasShow: `${moduleName}/toggleAktivitasShow`,
            setLoadMore: `${moduleName}/setLoadMore`,
            getListAktivitas: `${moduleName}/getListAktivitas`,
        }),
        openDetail(e) {
            console.log(e);
        },
        async doLoadMore() {
            if (this.aktivitasTotal > this.aktivitasPage.length) {
                if (!this.isFetching) {
                    await this.setLoadMore(true);
                    await this.getListAktivitas({ iddevice: this.iddevice, idStatus: this.idStatus });
                }
            }
        },
        toggleCard(data) {
            this.toggleAktivitasShow(data);
        },
    },
};
</script>
<style scoped>
.wa-device-container {
    margin: -10px 0 0 -18px;
}

.wa-device {
    background: #f6f6f6;
    border-top-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    padding: 4px 8px;
    max-width: 200px;

    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.wa-status-thumbnail {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 8px;
    border-color: #ededed;
    height: 100px;
    width: 100px;
}

.wa-status-thumbnail img {
    width: 100%;
    height: auto;
}

.wa-status-status {
    border-radius: 4px;
    padding: 2px 4px;
}

.wa-status-status.green {
    color: #40964c;
    background-color: #e8fcee;
}

.wa-status-status.red {
    color: #964040;
    background-color: #fff1f1;
}

.wa-status-status.blue {
    color: #206cff;
    background-color: #e2f0ff;
}
</style>
